export type TimestampedObject = {
  value: string;
  expire: number;
};

export function getValidatedValueFromLocalStorage(key: string): string | null {
  const value: string | null = localStorage.getItem(key);
  if (!value) {
    return null;
  }

  const timestampedObject: TimestampedObject | null =
    parseJsonIntoTimestampedObject(value);
  if (timestampedObject && validateTimestamp(timestampedObject)) {
    return timestampedObject.value;
  }
  return null;
}

function validateTimestamp(value: TimestampedObject): boolean {
  return Date.now() <= value.expire;
}

function parseJsonIntoTimestampedObject(
  value: string,
): TimestampedObject | null {
  try {
    return JSON.parse(value) as TimestampedObject;
  } catch (e) {
    // failed to parse JSON or convert into TimestampedValue
    return null;
  }
}
